import { useState } from 'react';
import useWindowResizeListener from './useWindowResizeListener';

const tabletPortraitBreakpoint = 998;
const tabletLandscapeBreakpoint = 1194;

interface useBreakpointResult {
  isTabletPortrait: boolean;
  isTabletLandscape: boolean;
  isDesktop: boolean;
}

const CS_WEB_MFE_DOM_ID = 'single-spa-application:@creditsights/cs-web';
const CREDITSIGHTS_MFE_DOM_ID = 'single-spa-application:@creditsights/creditsights-web';

// When navigating between different MFE, for a blink of a second, both @creditsights/creditsights-web and @creditsights/cs-web co-exists in a DOM tree.
// In some cases, this causes issues similar to CSNP-2150/CSNP-2290 where initial isDesktop value is calculated incorrectly due to window.innerWidth being double the size (2 MFE side by side).
// to workaround this issue, when setting the initial values we check if @creditsights/cs-web MFE exists in the DOM and window.innerWidth = csWebWidth + creditsightsWidth, if so -> divide the window.innerWidth by two.
const getWidthForInitialState = () => {
  const csWebMfe = document.getElementById(CS_WEB_MFE_DOM_ID);
  const creditSightsMfe = document.getElementById(CREDITSIGHTS_MFE_DOM_ID);
  const shouldDivide = !!csWebMfe && csWebMfe.clientWidth + creditSightsMfe!.clientWidth === window.innerWidth;
  return shouldDivide ? window.innerWidth / 2 : window.innerWidth;
};

const useBreakpoint = (): useBreakpointResult => {
  const initialWidth = getWidthForInitialState();
  const [isTabletPortrait, setIsTabletPortrait] = useState<boolean>(initialWidth <= tabletPortraitBreakpoint);
  const [isTabletLandscape, setIsTabletLandscape] = useState<boolean>(
    initialWidth > tabletPortraitBreakpoint && initialWidth < tabletLandscapeBreakpoint
  );
  const [isDesktop, setIsDesktop] = useState<boolean>(initialWidth > tabletLandscapeBreakpoint);

  const updateMedia = () => {
    setIsTabletPortrait(window.innerWidth <= tabletPortraitBreakpoint);
    setIsTabletLandscape(
      window.innerWidth > tabletPortraitBreakpoint && window.innerWidth <= tabletLandscapeBreakpoint
    );
    setIsDesktop(window.innerWidth > tabletLandscapeBreakpoint);
  };
  useWindowResizeListener(updateMedia);
  return { isTabletPortrait, isTabletLandscape, isDesktop };
};
export default useBreakpoint;
